import React from 'react';
import { useApolloClient } from '@apollo/client';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import IdeaShowJoyride from '@buyside/components/presentation/Joyride/IdeaShowJoyride/ideaShowJoyride';
import InfoTable from '@buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import QuickPosition from '@buyside/components/presentation/QuickPosition/quickPosition';
import { IdeaShowJoyrideTarget } from '@buyside/components/presentation/Joyride/IdeaShowJoyride/ideaShowJoyrideHelper';

import { IdeaPositionsQuery } from '@interfaces/graphql-typings';

const IdeaPositions = require('buyside/graphql/queries/ideaShowPage/IdeaPositions');

const QuickPositions: React.FC<{ ideaId: string }> = ({ ideaId }) => {
  const client = useApolloClient();

  const cachedPosIdea = client.readQuery<IdeaPositionsQuery>({
    query: IdeaPositions,
    variables: { ideaId }
  })?.idea;

  const assetIds = cachedPosIdea?.positions.map(position => position.asset?.id);

  if (!assetIds?.length) return null;

  return (
    <ErrorBoundary pageName="the quick position">
      <div id="quick-positions" data-joyride-target={IdeaShowJoyrideTarget.CREATE_QUICK_POSITION}>
        <InfoTable title="Your Quick Positions">
          {(): React.ReactElement => (
            <>
              {assetIds.map(assetId =>
                assetId ? (
                  <QuickPosition assetId={assetId} key={`quick-position-asset-${assetId}`} />
                ) : null
              )}
            </>
          )}
        </InfoTable>
        <IdeaShowJoyride />
      </div>
    </ErrorBoundary>
  );
};

export default QuickPositions;
